export const validateRedirects = (redirects, existingRedirects) => {
  let errorMessages = []
  redirects.forEach(rd => {
    if (!rd.from.startsWith('/')) {
      errorMessages.push('FROM url: [' + rd.from + '] must starts from / char')
    }
    if (rd.from.indexOf(' ') !== -1) {
      errorMessages.push('FROM url: [' + rd.from + '] must be without spaces')
    }
    redirects.forEach(rd1 => {
      if (rd1.to === rd.from) {
        errorMessages.push('FROM url: [' + rd.from + '] has equal value in TO url: [' + rd1.to + ']')
      }
      if (rd.key !== rd1.key && rd.from === rd1.from) {
        errorMessages.push('FROM url: [' + rd.from + '] has equal value in FROM url: [' + rd1.from + ']')
      }
    })
    if (!rd.to.startsWith('http') && !rd.to.startsWith('/')) {
      errorMessages.push('TO url: [' + rd.to + '] must starts from / char or HTTP(s) protocol')
    }
    if (rd.to.indexOf(' ') !== -1) {
      errorMessages.push('TO url: [' + rd.to + '] must be without spaces')
    }
    if (rd.exclude && rd.exclude.length > 0) {
      rd.exclude.forEach(domain => {
        if (domain === '') {
          errorMessages.push('Excluded domain can not be empty')
        }
        if (domain.indexOf(' ') >= 0) {
          errorMessages.push('Excluded domain can not contains white spaces')
        }
        if (domain.indexOf('/') >= 0 || domain.indexOf('http:') >= 0 || domain.indexOf('https:') >= 0) {
          errorMessages.push('Excluded domain can not contains any symbols like / or protocols')
        }
      })
    }
    if (existingRedirects && existingRedirects.some(redirect => redirect.from === rd.from)) {
      errorMessages.push('FROM url: [' + rd.from + '] already exists')
    }
  })
  return errorMessages
}
